<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Cidadãos CNS inválido"
            description="Cidadãos que precisam atualizar o CNS"
            url="/dashboard"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <tabela-cadastros
            ref="table"
            :cadastros="displayedCadastros"
            :loading="loading"
            @filterSearch="filterSearch($event)"
          ></tabela-cadastros>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import { mapState } from 'vuex'
import utils from '@/mixins/utils.js'
import TabelaCadastros from './TabelaCadastros.vue'

export default {
  name: 'CidadaosCnsInvalidos',
  components: {
    Menu,
    Footer,
    SectionTitle,
    TabelaCadastros,
  },
  mixins: [utils],
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
  },
  data() {
    return {
      loading: false,
      cadastros: [],
      cadastrosOriginais: [],
      filterSearchTable: false,
    }
  },
  methods: {
    /**
     * Atualiza o estado do filtro de busca da tabela.
     * @param {Object} item Item selecionado
     */
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },

    /**
     * Buscar dados
     */
    async buscarDadosIniciais() {
      try {
        this.loading = true
        let response = await this.$api.get(
          '/app/cidadaos-cns-invalidos/' +
            this.$store.state.cod_ibge +
            '/' +
            this.$store.state.nu_ine
        )
        this.cadastros = []
        this.cadastros = response.data
        this.cadastrosOriginais = response.data
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    /**
     * Inicializa os dados
     */
    init() {
      this.buscarDadosIniciais()
    },
  },
  created() {
    this.init()
  },
}
</script>

<style src="./styles.scss" scoped lang="scss" />
